<template>
	<v-navigation-drawer v-model="dialog" width="420" fixed right temporary>
		<v-card elevation="0">
			<v-card-title>
				资质进度<v-spacer />
				<v-btn class="mx-0" icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider />
			<v-list-item class="py-1">
				<v-list-item-avatar size="56">
					<v-img :src="recordView.projIcon"></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="font-weight-bold mb-2">{{ recordView.projName }}</v-list-item-title>
					<v-list-item-subtitle class="caption">{{ recordView.projNote }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-divider />
			<v-card-text class="grey--text pb-0">
				<p class="mb-2">
					业务人员：<span class="blue-grey--text">{{ recordView.linkName }}</span>
				</p>
				<p class="mb-2">
					业务电话：<span class="blue-grey--text">{{ recordView.linkTele }}</span>
				</p>
				<p class="mb-2">
					服务地区：<span class="blue-grey--text">{{ recordView.areaName }}</span>
				</p>
				<p class="mb-2">
					有效期限：<span class="blue-grey--text">{{ recordView.btime | date("yyyy-MM-dd") }} ~ {{ recordView.etime | date("yyyy-MM-dd") }}</span>
				</p>
				<p class="mb-2">资质材料：<a :href="`${recordView.file}`" target="_blank" class="blue--text pointer">查看文件</a></p>
				<p>
					申请说明：<span class="blue-grey--text">{{ recordView.note }}</span>
				</p>
			</v-card-text>
			<v-divider />
			<v-timeline v-if="examList.length > 0" dense>
				<v-timeline-item v-for="(item, index) in examList" :key="index" color="blue" small class="elevation-0">
					<div>
						<h4 class="font-weight-medium">
							{{ item.name }}
							<v-chip v-if="item.name == '审核'" :color="item.state | dict('0:red/1:green')" class="white--text px-2 ml-1" style="height: 20px" small label> {{ item.state | dict("0:不通过/1:通过") }} </v-chip>
							<span class="float-right grey--text caption mr-4">{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}</span>
						</h4>
						<p class="blue-grey--text caption mt-1 mb-1 pr-3">人员：{{ item.operator }}</p>
						<p class="blue-grey--text caption mb-0 pr-3">说明：{{ item.stateNote }}</p>
					</div>
				</v-timeline-item>
			</v-timeline>
		</v-card>
	</v-navigation-drawer>
</template>

<script>
export default {
	data() {
		return {
			dialog: false,
			recordView: {},
			examList: [],
		};
	},
	mounted() {},
	methods: {
		view(item) {
			this.recordView = item;
			this.examList = item.stateJson ? JSON.parse(item.stateJson) : [];
			console.log(this.examList);
			this.dialog = true;
		},
	},
};
</script>

<style lang="scss" scoped></style>
